import { SignUpPayload } from "@/models/payload/auth";
import { RefreshTokenCommand } from "@/models/club";
import clubRequest from "../axios";
import {
  CheckUserPayload,
  ResetPasswordPayload,
  SendOtpCodePayload,
  SignInPayload,
  TokenDTo,
  UserVerifyOtpPayload,
  VerifyForgetPasswordOtpPayload,
  VerifySignUpPayload,
} from "./type";

const sendCode = async (payload: SignUpPayload) =>
  (await clubRequest.authenticateSignUpCreate(payload)).data;

const checkUser = async (payload: CheckUserPayload) =>
  (await clubRequest.authenticateCheckUserCreate(payload)).data;

const loginByPassword = async (payload: SignInPayload) =>
  (await clubRequest.authenticateSignInCreate(payload)).data;

const loginWithOtpCode = async (payload: SendOtpCodePayload) =>
  (await clubRequest.authenticateSignInWithOtpCreate(payload)).data;

const verifyOtp = async (payload: UserVerifyOtpPayload) =>
  (await clubRequest.authenticateVerifyOtpLoginCreate(payload)).data;

const SignUp = async (payload: SignUpPayload) =>
  (await clubRequest.authenticateSignUpCreate(payload)).data;

const SignUpVerify = async (payload: VerifySignUpPayload) =>
  (await clubRequest.authenticateVerifySignUpCreate(payload)).data;

const sendResetPasswordOtp = async (payload: SendOtpCodePayload) =>
  (await clubRequest.authenticateForgetPasswordOtpCreate(payload)).data;

const verifyForgetPasswordOtp = async (
  payload: VerifyForgetPasswordOtpPayload
) =>
  (await clubRequest.authenticateVerifyOtpForgetPasswordCreate(payload))
    .data;

const resetPassword = async (payload: ResetPasswordPayload) =>
  (await clubRequest.authenticateResetPasswordCreate(payload)).data;

const refreshToken = async (payload: RefreshTokenCommand) =>
  (await clubRequest.authenticateRefreshTokenCreate(payload))
    .data as unknown as TokenDTo;

const authService = {
  checkUser,
  sendCode,
  loginByPassword,
  loginWithOtpCode,
  verifyOtp,
  SignUp,
  SignUpVerify,
  sendResetPasswordOtp,
  verifyForgetPasswordOtp,
  resetPassword,
  refreshToken,
};

export default authService;
